const templateNews = {
  init: function () {
    this.load_more();
  },

  load_more: function () {
    var btn = $(".news__more");
    var page;
    btn.on("click", function () {
      page = btn.attr("data-page");
      page++;
      btn.attr("data-page", page);
      $.ajax({
        url: ajaxurl,
        type: "POST",
        data: {
          action: "news_load",
          page: page,
        },
        beforeSend: function () {
          // Loader
          btn.addClass("loading");

          btn.attr("disabled", true);
        },
        success: function (response) {
          // Loader
          if (response.success) {
            btn.removeClass("loading");
            btn.attr("disabled", false);
            $(".news__inner .clearfix").before(response.data);
          } else {
            btn.remove();
          }
        },
      });
    });
  },
};

export default templateNews;
